(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["video-hero-logo"] && !Shopify.designMode) return;
  try {
    
  // Qui potresti aggiungere JavaScript se necessario

  } catch(e) { console.error(e); }
})();
})();
